import { ReferenceManyField, TextField } from 'react-admin';
import { MainDatagridStyled } from '@/styles/overrides';
import { FCRAWorker } from '@/types/turn-api';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import ActiveSwitch from './ActiveSwitch';
import TextColumn from './TextColumn';
import { path } from './constants';
import SetCurrentButton from './SetCurrentButton';
import EditButton from './EditButton';

type TableProps = {
  onEdit?: (address: FCRAWorker.Address) => void;
};

const Table = ({ onEdit }: TableProps) => {
  return (
    <ReferenceManyField reference={TurnReferencesEnum.Candidates} target={TurnTargetsEnum.Addresses} label="">
      <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
        <ActiveSwitch />
        <TextField emptyText="false" sortable={false} source={path('active')} />
        <TextColumn label="Street" sortable={false} source="address1" />
        <TextColumn sortable={false} source={path('city')} />
        <TextColumn sortable={false} source={path('state')} />
        <TextColumn sortable={false} source={path('zip')} />
        <TextColumn sortable={false} source={path('county')} />
        <TextColumn label="First Seen" sortable={false} source={path('first_seen')} />
        <TextColumn label="Last Seen" sortable={false} source={path('last_seen')} />
        <SetCurrentButton label="" sortable={false} source={path('id')} />
        {onEdit && <EditButton label="" sortable={false} source={path('id')} onEdit={onEdit} />}
      </MainDatagridStyled>
    </ReferenceManyField>
  );
};

export default Table;
